<template>
  <ToolsPageDetail :tool="tool" />
</template>

<script>
import ToolsPageDetail from '@/components/tools/ToolsPageDetail';
import ToolModel from '@/models/Tool';
import { buildMetaHead } from '@/helpers/meta';

export default {
  name: 'PageToolsId',
  components: {
    ToolsPageDetail
  },
  data: () => ({
    tool: null
  }),
  head() {
    return buildMetaHead({
      title: 'Deals | ' + this.tool.title,
      description: this.tool.text,
      path: this.tool.url,

      ...(this &&
        this.tool &&
        this.tool.image &&
        this.tool.image.thumbnailSizeUrl && { imageUrl: this.tool.image.thumbnailSizeUrl })
    });
  },
  async asyncData({ params, $axios, error }) {
    try {
      const { data } = await $axios.get('tools/' + params.id);

      return {
        tool: data.tool
      };
    } catch (err) {
      error(err);
    }
  },
  created() {
    this.tool = this.tool ? new ToolModel(this.tool) : null;
  },
  mounted() {
    // console.log('mounted this.$route.path', this.$route.path, this.$route)
    this.$router.push({
      path: `/deals/${this.$route?.params?.id}`
    });
  }
};
</script>
